export const formatGender = gender => {
  if (!gender) return;

  const lowerCaseGender = gender.toLowerCase();

  if (['f', 'female'].includes(lowerCaseGender)) {
    return 'Female';
  }
  if (['m', 'male'].includes(lowerCaseGender)) {
    return 'Male';
  }
};

/**
 * Converts base64 string to object. On failure, returns null.
 * @param {*} base64 - base64 string
 * @returns {object} object
 */
export const base64ToObject = base64 => {
  try {
    return JSON.parse(Buffer.from(base64, 'base64').toString());
  } catch {
    return null;
  }
};

export const doesStartWithVowel = string => {
  if (!string) {
    return false;
  }

  const firstLetter = string.charAt(0).toLowerCase();
  return ['a', 'e', 'i', 'o', 'u'].includes(firstLetter);
};

export const capitalizeFirstLetter = string => {
  if (!string) {
    return '';
  }

  return `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
};

/**
 * Pluralizes a word based on the number
 * @param {number} number - The number to pluralize
 * @param {string} singular - The singular form of the word
 * @param {string} plural - The plural form of the word
 * @returns {string} - The pluralized word
 * @example
 * pluralize(1, 'person', 'people') // '1 person'
 * pluralize(2, 'person', 'people') // '2 people'
 */
export const pluralize = (number, singular, plural) => {
  const parsedNumber = Number(number);
  return parsedNumber === 1
    ? `${parsedNumber} ${singular}`
    : `${parsedNumber} ${plural}`;
};
